module.exports = __webpack_public_path__ + "static/media/icon-user-graduate.ac93b573.svg";